import { createContext } from 'react';

type ThemeContextProps = {
  isDarkTheme: boolean;
  toggleTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextProps>({
  isDarkTheme: true,
  /**
   * ToogleTheme function for changing the theme of the application.
   */
  toggleTheme: () => {}
});

export const ThemeContextProvider = ThemeContext.Provider;
